import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Swal from 'sweetalert2'
import axios from 'axios'
import { Controller, useForm } from 'react-hook-form'
import {
    Autocomplete,
    Divider,
    Fab,
    FormControl,
    FormHelperText,
    TextField,
} from '@mui/material'

import { useNavigate } from "react-router-dom";
import Icon from '../../../components/icon';
import { SyntheticEvent, useEffect, useState } from 'react'
import appInfo from '../../../configs/app-info';
import apiUrl from '../../../configs/constant';
import { getDoctag, getCustomer, getSales, getDesigner } from '../../../api/helper';

interface Props {
    contact: any
    onClose: () => void
    onNavigate?: (id) => void
}

export default function AddQuotation({ contact, onClose, onNavigate }: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();

    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [listSales, setListSales] = useState<any[]>([])

    const [valDesigner, setValDesigner] = useState<any>(null)
    const [listDesigner, setListDesigner] = useState<any[]>([])

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        sdcust_id: any,
        sdsalesman_id: any,
        nomor_po: any,
        tgl: any,
        tgl_close: any,
        tgl_kirim: any,
        keterangan: any,
        designer_id: any,
    }

    const defaultValues = {
        sdcust_id: contact?.sdcust_id,
        syscabang_id: cabang,
        tgl: new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).toISOString().substring(0, 16),
        tgl_close: new Date(new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).setDate(new Date().getDate() + 7)).toISOString().substring(0, 16),
        tgl_kirim: new Date(new Date(new Date().getTime() + (7 * 60 * 60 * 1000)).setDate(new Date().getDate() + 7)).toISOString().substring(0, 16),
    }

    useEffect(() => {
        const fetchDoctag = async () => {
            const response = await getDoctag(appInfo.menuId.quotation, cabang, token);
            if (response.length > 0 && response.length == 1) {
                setValue('sysdoctag_id', response[0].id)
            }
            setListDoctag(response);
        };
        const fetchSales = async () => {
            const response = await getSales(token);
            response.forEach(element => {
                if (element.hrstaff_id == contact?.hrstaff_id) {
                    setValue('sdsalesman_id', element.id)
                }
            });
            setListSales(response);
        };
        const fetchDesigner = async () => {
            const response = await getDesigner(cabang, token);
            setListDesigner(response);
        };
        fetchDoctag();
        fetchSales();
        fetchDesigner();
    }, [])

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const handleChangeAutocompleteDesigner = (event: SyntheticEvent, newValue: any | null) => {
        setValue('designer_id', newValue ? newValue.id : null)
        setValDesigner(newValue)
    }

    const onSubmit = async (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/quotation/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    const id = response.data.data
                                    onNavigate(id)
                                    // navigate('/sales/quotation/detail/' + response.data.data)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })

    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3} sx={{ mt: 1 }}>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                        <Autocomplete
                            value={valDesigner}
                            options={listDesigner}
                            id='designer_id'
                            isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                            onChange={handleChangeAutocompleteDesigner}
                            getOptionLabel={(option: any) => option?.nama || ""}   // 👈 penting
                            renderOption={(props: any, option: any) => {
                                return (
                                    <li {...props} key={option.id}>
                                        {option.nama}
                                    </li>
                                )
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    required
                                    label='Designer'
                                    InputLabelProps={{ shrink: true }}
                                />
                            )}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                        <Controller
                            name='tgl'
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <TextField
                                    type='datetime-local'
                                    value={value}
                                    label='Tanggal'
                                    onChange={onChange}
                                    InputLabelProps={{ shrink: true }}
                                    error={Boolean(errors.tgl)}
                                />
                            )}
                        />
                        {errors.tgl && (
                            <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                        <Controller
                            name='tgl_close'
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <TextField
                                    type='datetime-local'
                                    value={value}
                                    label='Tanggal Close'
                                    onChange={onChange}
                                    InputLabelProps={{ shrink: true }}
                                    error={Boolean(errors.tgl_close)}
                                />
                            )}
                        />
                        {errors.tgl_close && (
                            <FormHelperText sx={{ color: 'error.main' }}>Tanggal Close harus diisi</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                        <Controller
                            name='tgl_kirim'
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <TextField
                                    type='datetime-local'
                                    value={value}
                                    label='Tanggal Kirim'
                                    onChange={onChange}
                                    InputLabelProps={{ shrink: true }}
                                    error={Boolean(errors.tgl_kirim)}
                                />
                            )}
                        />
                        {errors.tgl_kirim && (
                            <FormHelperText sx={{ color: 'error.main' }}>Tanggal Kirim harus diisi</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12}>
                    <FormControl fullWidth>
                        <Controller
                            name='keterangan'
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='Keterangan'
                                    onChange={onChange}
                                    multiline
                                    rows={4}
                                />
                            )}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <Button
                        type="submit"
                        variant="contained"
                    >
                        Simpan
                    </Button>

                    <Button
                        sx={{ ml: 2 }}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                </Grid>

            </Grid>

        </form>
    )
}
